module.exports = __webpack_public_path__ + "static/media/laola-logo.509f7807.png";